module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "exam-content m0 cb pr"
  }, [_c('article', {
    staticClass: "fl exam-left"
  }, [_c('h3', {
    staticClass: "tc h3"
  }, [_vm._v(_vm._s(_vm.laseExamList.name))]), _vm._v(" "), _c('div', {
    staticClass: "exam-score-wrap m0"
  }, [_c('div', {
    staticClass: "exam-score-left fl"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fl fx"
  }, [_c('p', {
    staticClass: "m0 tc"
  }, [_c('span', {
    staticClass: "f14 tc"
  }, [_vm._v(_vm._s(_vm.questionTotals.score))]), _vm._v("\n                            /" + _vm._s(_vm.questionTotals.totalScore) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "exam-score-left exam-score-right fr"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fl fx"
  }, [_c('p', {
    staticClass: "m0 tc"
  }, [_c('span', {
    staticClass: "f14 tc"
  }, [_vm._v(_vm._s(_vm.questionTotals.questionCount))]), _vm._v("\n                            /" + _vm._s(_vm.questionTotals.totalQuestionCount) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "exam-nav cb mb20"
  }, _vm._l((_vm.questionTypeSummaries), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "m0"
    }, [(item.type == '001001') ? _c('li', {
      staticClass: "first"
    }, [_c('a', {
      class: {
        active: _vm.type == '001001'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001001');
        }
      }
    }, [_vm._v("单选题")])]) : _vm._e(), _vm._v(" "), (item.type == '001002') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001002'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001002');
        }
      }
    }, [_vm._v("多选题")])]) : _vm._e(), _vm._v(" "), (item.type == '001003') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001003'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001003');
        }
      }
    }, [_vm._v("判断题")])]) : _vm._e(), _vm._v(" "), (item.type == '001004') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001004'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001004');
        }
      }
    }, [_vm._v("填空题")])]) : _vm._e(), _vm._v(" "), (item.type == '001005') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001005'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001005');
        }
      }
    }, [_vm._v("简答题")])]) : _vm._e(), _vm._v(" "), (item.type == '001006') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001006'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001006');
        }
      }
    }, [_vm._v("案例题")])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "examOverscroll fl"
  }, _vm._l((_vm.questionTypeSummaries), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "option-question m0 active"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type == '001001' && item.type == _vm.type),
        expression: "item.type == '001001' && item.type == type"
      }]
    }, [_c('p', {
      staticClass: "explainText mt20 pl10"
    }, [_vm._v("一、" + _vm._s(item.description))]), _vm._v(" "), _vm._l((item.questions), function(questionsItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-div"
      }, [_c('i', {
        staticClass: "fl mr10 active"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
        staticClass: "f14 fl",
        domProps: {
          "innerHTML": _vm._s(questionsItem.content)
        }
      }), _vm._v(" "), _vm._l((questionsItem.choices), function(choicesItem, index) {
        return _c('div', {
          key: index,
          staticClass: "option-list-radio ml40 cb"
        }, [_c('div', {
          staticClass: "oh"
        }, [_c('el-radio', {
          attrs: {
            "label": choicesItem.code
          },
          model: {
            value: (questionsItem.userAnswer),
            callback: function($$v) {
              _vm.$set(questionsItem, "userAnswer", $$v)
            },
            expression: "questionsItem.userAnswer"
          }
        }, [_c('span', [_vm._v(_vm._s(choicesItem.code))])]), _vm._v(" "), _c('div', {
          staticClass: "oh fl",
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_c('span', {
          staticClass: "exam-words fl",
          domProps: {
            "innerHTML": _vm._s(choicesItem.content)
          }
        })])], 1)])
      }), _vm._v(" "), _c('div', {
        staticClass: "result pt20 ml40 cb"
      }, [_c('p', {
        staticClass: "f14 cuo"
      }, [_vm._v("\n                                    您的答案：" + _vm._s(questionsItem.userAnswer) + "\n                                    "), (questionsItem.userAnswer != questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/cha_03.png",
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), (questionsItem.userAnswer == questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/dui_07.png",
          "alt": ""
        }
      })]) : _vm._e()]), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('p', {
        staticClass: "f14 dui"
      }, [_c('span', [_vm._v("正确答案为：")]), _vm._v("\n                                    " + _vm._s(questionsItem.answer) + "\n                                    "), _vm._m(2, true)]) : _vm._e(), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('div', {
        staticClass: "f14 jiexi"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("解析:")]), _vm._v(" "), _c('p', {
        staticClass: "fl ml5",
        domProps: {
          "innerHTML": _vm._s(questionsItem.analysis)
        }
      })]) : _vm._e()])], 2)
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type == '001002' && item.type == _vm.type),
        expression: "item.type == '001002' && item.type == type"
      }]
    }, [_c('p', {
      staticClass: "explainText mt20 pl10"
    }, [_vm._v("一、" + _vm._s(item.description))]), _vm._v(" "), _vm._l((item.questions), function(questionsItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-div"
      }, [_c('i', {
        staticClass: "fl mr10 active"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
        staticClass: "f14 fl",
        domProps: {
          "innerHTML": _vm._s(questionsItem.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "result pt20 ml40 cb"
      }, [_c('p', {
        staticClass: "f14 cuo"
      }, [_vm._v("\n                                    您的答案：" + _vm._s(questionsItem.userAnswer) + "\n                                    "), (questionsItem.userAnswer != questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/cha_03.png",
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), (questionsItem.userAnswer == questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/dui_07.png",
          "alt": ""
        }
      })]) : _vm._e()]), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('p', {
        staticClass: "f14 dui"
      }, [_c('span', [_vm._v("正确答案为：")]), _vm._v("\n                                    " + _vm._s(questionsItem.answer) + "\n                                    "), _vm._m(3, true)]) : _vm._e(), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('div', {
        staticClass: "f14 jiexi"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("解析:")]), _vm._v(" "), _c('p', {
        staticClass: "fl ml5",
        domProps: {
          "innerHTML": _vm._s(questionsItem.analysis)
        }
      })]) : _vm._e()])])
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type == '001003' && item.type == _vm.type),
        expression: "item.type == '001003' && item.type == type"
      }]
    }, [_c('p', {
      staticClass: "explainText mt20 pl10"
    }, [_vm._v("一、" + _vm._s(item.description))]), _vm._v(" "), _vm._l((item.questions), function(questionsItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-div"
      }, [_c('i', {
        staticClass: "fl mr10 active"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
        staticClass: "f14 fl",
        domProps: {
          "innerHTML": _vm._s(questionsItem.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "result pt20 ml40 cb"
      }, [_c('p', {
        staticClass: "f14 cuo"
      }, [_vm._v("\n                                    您的答案：" + _vm._s(questionsItem.userAnswer) + "\n                                    "), (questionsItem.userAnswer != questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/cha_03.png",
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), (questionsItem.userAnswer == questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/dui_07.png",
          "alt": ""
        }
      })]) : _vm._e()]), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('p', {
        staticClass: "f14 dui"
      }, [_c('span', [_vm._v("正确答案为：")]), _vm._v("\n                                    " + _vm._s(questionsItem.answer) + "\n                                    "), _vm._m(4, true)]) : _vm._e(), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('div', {
        staticClass: "f14 jiexi"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("解析:")]), _vm._v(" "), _c('p', {
        staticClass: "fl ml5",
        domProps: {
          "innerHTML": _vm._s(questionsItem.analysis)
        }
      })]) : _vm._e()])])
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type == '001004' && item.type == _vm.type),
        expression: "item.type == '001004' && item.type == type"
      }]
    }, [_c('p', {
      staticClass: "explainText mt20 pl10"
    }, [_vm._v("一、" + _vm._s(item.description))]), _vm._v(" "), _vm._l((item.questions), function(questionsItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-div option-div-tk"
      }, [_c('i', {
        staticClass: "fl mr10 active"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
        staticClass: "f14 fl",
        domProps: {
          "innerHTML": _vm._s(questionsItem.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "result pt20 ml40 cb option-div-tk"
      }, [_c('p', {
        staticClass: "f14 cuo"
      }, [_vm._v("\n                                    您的答案：" + _vm._s(questionsItem.userAnswer) + "\n                                    "), (questionsItem.userAnswer != questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/cha_03.png",
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), (questionsItem.userAnswer == questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/dui_07.png",
          "alt": ""
        }
      })]) : _vm._e()]), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('p', {
        staticClass: "f14 dui"
      }, [_c('span', [_vm._v("正确答案为：")]), _vm._v("\n                                    " + _vm._s(questionsItem.answer) + " \n                                    "), _vm._m(5, true)]) : _vm._e(), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('div', {
        staticClass: "f14 jiexi"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("解析:")]), _vm._v(" "), _c('p', {
        staticClass: "fl ml5",
        domProps: {
          "innerHTML": _vm._s(questionsItem.analysis)
        }
      })]) : _vm._e()])])
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type == '001005' && item.type == _vm.type),
        expression: "item.type == '001005' && item.type == type"
      }]
    }, [_c('p', {
      staticClass: "explainText mt20 pl10"
    }, [_vm._v("一、" + _vm._s(item.description))]), _vm._v(" "), _vm._l((item.questions), function(questionsItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-div"
      }, [_c('div', {
        staticClass: "question-box"
      }, [_c('i', {
        staticClass: "fl mr10 active"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
        staticClass: "f14 fl",
        domProps: {
          "innerHTML": _vm._s(questionsItem.content)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "result pt20 ml40 cb"
      }, [_c('p', {
        staticClass: "f14 cuo"
      }, [_vm._v("\n                                    您的答案：" + _vm._s(questionsItem.userAnswer) + "\n                                    "), (questionsItem.userAnswer != questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/cha_03.png",
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), (questionsItem.userAnswer == questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/dui_07.png",
          "alt": ""
        }
      })]) : _vm._e()]), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('p', {
        staticClass: "f14 dui"
      }, [_c('span', [_vm._v("正确答案为：")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(questionsItem.answer)
        }
      }), _vm._v(" "), _vm._m(6, true)]) : _vm._e(), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('div', {
        staticClass: "f14 jiexi"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("解析:")]), _vm._v(" "), _c('p', {
        staticClass: "fl ml5",
        domProps: {
          "innerHTML": _vm._s(questionsItem.analysis)
        }
      })]) : _vm._e()])])
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type == '001006' && item.type == _vm.type),
        expression: "item.type == '001006' && item.type == type"
      }]
    }, [_c('p', {
      staticClass: "explainText mt20 pl10"
    }, [_vm._v("一、" + _vm._s(item.description))]), _vm._v(" "), _vm._l((item.questions), function(questionsItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-div"
      }, [_c('div', {
        staticClass: "question-box"
      }, [_c('i', {
        staticClass: "fl mr10 active"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
        staticClass: "f14 fl",
        domProps: {
          "innerHTML": _vm._s(questionsItem.content)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "result pt20 ml40 cb"
      }, [_c('p', {
        staticClass: "f14 cuo"
      }, [_vm._v("\n                                    您的答案：" + _vm._s(questionsItem.userAnswer) + "\n                                    "), (questionsItem.userAnswer != questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/cha_03.png",
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), (questionsItem.userAnswer == questionsItem.answer) ? _c('i', [_c('img', {
        attrs: {
          "src": "/static/images/dui_07.png",
          "alt": ""
        }
      })]) : _vm._e()]), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('p', {
        staticClass: "f14 dui"
      }, [_c('span', [_vm._v("正确答案为：")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(questionsItem.answer)
        }
      }), _vm._v(" "), _vm._m(7, true)]) : _vm._e(), _vm._v(" "), (_vm.laseExamList.ifDisplayAnswer) ? _c('div', {
        staticClass: "f14 jiexi"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("解析:")]), _vm._v(" "), _c('p', {
        staticClass: "fl ml5",
        domProps: {
          "innerHTML": _vm._s(questionsItem.analysis)
        }
      })]) : _vm._e()])])
    })], 2)])
  }), 0)]), _vm._v(" "), _c('article', {
    staticClass: "fr exam-right"
  }, [_c('div', {
    staticClass: "exam-right-box"
  }, [_c('div', {
    staticClass: "exam-txbox mt15 fl"
  }, [_c('span', {
    staticClass: "pr fl"
  }, [_vm._m(8), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "block",
      "border-radius": "50px"
    },
    attrs: {
      "src": _vm.userHeadImagUrl,
      "alt": "",
      "width": "53",
      "height": "53"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fl"
  }, [_c('span', [_vm._v("-" + _vm._s(_vm.realName) + ",上午好")]), _vm._v(" "), _c('span', {
    staticClass: "fl"
  }, [_vm._v("总分 :")]), _vm._v(" "), _c('span', {
    staticClass: "fl score"
  }, [_vm._v("  " + _vm._s(_vm.laseExamList.totalScore) + "分")])])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "count-down count-down2"
  }, [_c('div', {
    staticClass: "collect-table mt20"
  }, [_c('ul', [_c('li'), _vm._v(" "), _vm._l((_vm.questionTypeSummaries), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.type == '001001') ? _c('span', {
      staticClass: "f12"
    }, [_vm._v("单选")]) : _vm._e(), _vm._v(" "), (item.type == '001002') ? _c('span', {
      staticClass: "f12"
    }, [_vm._v("多选")]) : _vm._e(), _vm._v(" "), (item.type == '001003') ? _c('span', {
      staticClass: "f12"
    }, [_vm._v("判断")]) : _vm._e(), _vm._v(" "), (item.type == '001004') ? _c('span', {
      staticClass: "f12"
    }, [_vm._v("填空")]) : _vm._e(), _vm._v(" "), (item.type == '001005') ? _c('span', {
      staticClass: "f12"
    }, [_vm._v("简答")]) : _vm._e(), _vm._v(" "), (item.type == '001006') ? _c('span', {
      staticClass: "f12"
    }, [_vm._v("案例")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "cb",
    attrs: {
      "border": "0"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "width": "51",
      "height": "36"
    }
  }, [_vm._v("答对")]), _vm._v(" "), _vm._l((_vm.questionScores), function(item, index) {
    return _c('td', {
      key: index,
      attrs: {
        "width": "51",
        "height": "36"
      }
    }, [_vm._v(_vm._s(item.right) + "\n                            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "51",
      "height": "36"
    }
  }, [_vm._v("答错")]), _vm._v(" "), _vm._l((_vm.questionScores), function(item, index) {
    return _c('td', {
      key: index,
      attrs: {
        "width": "51",
        "height": "36"
      }
    }, [_vm._v(_vm._s(item.error) + "\n                            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "51",
      "height": "36"
    }
  }, [_vm._v("未答")]), _vm._v(" "), _vm._l((_vm.questionScores), function(item, index) {
    return _c('td', {
      key: index,
      attrs: {
        "width": "51",
        "height": "36"
      }
    }, [_vm._v(_vm._s(item.empty) + "\n                            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "51",
      "height": "36"
    }
  }, [_vm._v("得分")]), _vm._v(" "), _vm._l((_vm.questionScores), function(item, index) {
    return _c('td', {
      key: index,
      attrs: {
        "width": "51",
        "height": "36"
      }
    }, [_vm._v(_vm._s(item.score) + "\n                            ")])
  })], 2)])]), _vm._v(" "), _c('p', {
    staticClass: "hand-over f14 tc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "selection-card"
  }, [_c('div', {
    staticClass: "exam-nav"
  }, _vm._l((_vm.questionTypeSummaries), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "m0"
    }, [(item.type == '001001') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001001'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001001');
        }
      }
    }, [_vm._v("单选题")])]) : _vm._e(), _vm._v(" "), (item.type == '001002') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001002'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001002');
        }
      }
    }, [_vm._v("多选题")])]) : _vm._e(), _vm._v(" "), (item.type == '001003') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001003'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001003');
        }
      }
    }, [_vm._v("判断题")])]) : _vm._e(), _vm._v(" "), (item.type == '001004') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001004'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001004');
        }
      }
    }, [_vm._v("填空题")])]) : _vm._e(), _vm._v(" "), (item.type == '001005') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001005'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001005');
        }
      }
    }, [_vm._v("简答题")])]) : _vm._e(), _vm._v(" "), (item.type == '001006') ? _c('li', [_c('a', {
      class: {
        active: _vm.type == '001006'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.menuBtn('001006');
        }
      }
    }, [_vm._v("案例题")])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "optionsBox oh"
  }, _vm._l((_vm.questionTypeSummaries), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "option-block m0"
    }, _vm._l((item.questions), function(questionsItem, index) {
      return _c('p', {
        key: index
      }, [_c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.type == '001001' && item.type == _vm.type),
          expression: "type == '001001'&& item.type==type"
        }],
        staticClass: "tc",
        class: {
          unanswered: !questionsItem.userAnswer
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.type == '001002' && item.type == _vm.type),
          expression: "type == '001002'&& item.type==type"
        }],
        staticClass: "tc",
        class: {
          unanswered: !questionsItem.userAnswer
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.type == '001003' && item.type == _vm.type),
          expression: "type == '001003' && item.type==type"
        }],
        staticClass: "tc",
        class: {
          unanswered: !questionsItem.userAnswer
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.type == '001004' && item.type == _vm.type),
          expression: "type == '001004' && item.type==type"
        }],
        staticClass: "tc",
        class: {
          unanswered: !questionsItem.userAnswer
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.type == '001005' && item.type == _vm.type),
          expression: "type == '001005' && item.type==type"
        }],
        staticClass: "tc",
        class: {
          unanswered: !questionsItem.userAnswer
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.type == '001006' && item.type == _vm.type),
          expression: "type == '001006'&& item.type==type "
        }],
        staticClass: "tc",
        class: {
          unanswered: !questionsItem.userAnswer
        }
      }, [_vm._v(_vm._s(index + 1))])])
    }), 0)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page-bj cb"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score fl"
  }, [_c('p', {
    staticClass: "m0 tc"
  }, [_c('i', {
    staticClass: "m0"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/score.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "clearfix f14 tc mt10"
  }, [_vm._v("您的得分")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score fl"
  }, [_c('p', {
    staticClass: "m0 tc"
  }, [_c('i', {
    staticClass: "m0"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/correct.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "clearfix f14 tc mt10"
  }, [_vm._v("答对题数")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/dui_07.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/dui_07.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/dui_07.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/dui_07.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/dui_07.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/dui_07.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/tx-vip_03.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-title fr"
  }, [_c('p', [_c('span', {
    staticClass: "f12"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/dt-bj.png",
      "alt": "",
      "height": "25"
    }
  }), _vm._v("\n            未答\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "f12"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/dt-bj3.png",
      "alt": "",
      "height": "25"
    }
  }), _vm._v("\n            已答\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6d860687"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/ExamScore.vue
// module id = 1163
// module chunks = 41